<template>
  <div class="menu-animal-container">
    <img class="menu-animal-img" :src="img" :alt="label">
    <div class="menu-animal-label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: ['icon', 'label'],
  computed: {
    img () {
      return `${process.env.BASE_URL}icons/${this.icon}.svg`
    }
  }
}
</script>

<style lang="scss">
  .menu-animal-container {
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    .menu-animal-img {

    }
    .menu-animal-label {
      font-family: Georgia;
      font-size: 12px;
      line-height: 1.33;
      color: #18333c;
      margin-left: 16px;
      align-self: center;
    }
  }
</style>
